import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";
import Select from "react-select";
import { smallFormSelectCustomStyles } from "../../../utils/SelectCustomStyles";
import logoInoxShipping from "../../../images/inox_logo.png";
import { format } from "date-fns";
import { downloadPDF } from "../../../utils/downloadPdf";



function PlannedExportExpenses(props) {
  const addcroform = useRef(null);
  const [shipmentData, setShipmentData] = useState([]);
  const [shipmentCroData, setShipmentCroData] = useState([]);
  const [shipmentDataPending, setShipmentDataPending] = useState(true);
  const [shipmentCroDataPending, setShipmentCroDataPending] = useState(true);

  const shipment_id = props.shipmentId
  const agentList = props.agentList
  const principalList = props.principalList
  const userList = props.userList
  const portList = props.portList
  const terminalList = props.terminalList
  const containerList = props.containerList
  const selectableContainerList = props.selectableContainerList
  const depotList = props.depotList
  const vesselList = props.vesselList
  const operatorList = props.operatorList
  const cargoList = props.cargoList
  const currentUserRolePermissionData = props.currentUserRolePermissionData
  const loggedInUser = props.loggedInUser

  // ----------------------- CRO --------------------------------
  const [showAddShipmentCroModal, setShowAddShipmentCroModal] = useState(false);
  const [showUpdateShipmentCroModal, setShowUpdateShipmentCroModal] = useState(false);
  const [showDeleteShipmentCroModal, setShowDeleteShipmentCroModal] = useState(false);
  const [showIssueCroModal, setShowIssueCroModal] = useState(false);
  const [showCancelCroModal, setShowCancelCroModal] = useState(false);

  const [updateShipmentCroId, setUpdateShipmentCroId] = useState("");
  const [updateDoNumber, setUpdateDoNumber] = useState("");
  const [updateVersion, setUpdateVersion] = useState("");
  const [updateShipmentPoa, setUpdateShipmentPoa] = useState("");
  const [updateShipmentPol, setUpdateShipmentPol] = useState("");
  const [updateShipmentPolTerminal, setUpdateShipmentPolTerminal] = useState("");
  const [updateShipmentPod, setUpdateShipmentPod] = useState("");
  const [updateShipmentFd, setUpdateShipmentFd] = useState("");
  const [updateShipmentVessel, setUpdateShipmentVessel] = useState("");
  const [updateShipmentVesselVoyage, setUpdateShipmentVesselVoyage] = useState("");
  const [updateShipmentVesselOperator, setUpdateShipmentVesselOperator] = useState("");
  const [updateShipmentVesselEta, setUpdateShipmentVesselEta] = useState("");
  const [updateShipmentVesselGateOpen, setUpdateShipmentVesselGateOpen] = useState("");
  const [updateShipmentVesselCutOff, setUpdateShipmentVesselCutOff] = useState("");
  const [updateShipmentVesselEtd, setUpdateShipmentVesselEtd] = useState("");
  const [updateShipmentBookingParty, setUpdateShipmentBookingParty] = useState("");
  const [updateShipmentBookingItem, setUpdateShipmentBookingItem] = useState("");
  const [updateShipmentContainer, setUpdateShipmentContainer] = useState("");
  const [updateCroStatus, setUpdateCroStatus] = useState("");
  const [updateCroValidity, setUpdateCroValidity] = useState("");
  const [updateCroIssueDate, setUpdateCroIssueDate] = useState("");
  const [updateCroIssuedBy, setUpdateCroIssuedBy] = useState("");
  const [updateCroSurveyor, setUpdateCroSurveyor] = useState("");
  const [updateCroSignAs, setUpdateCroSignAs] = useState("");
  const [updateCroSignAsName, setUpdateCroSignAsName] = useState("");
  const [updateCroSignAsStamp, setUpdateCroSignAsStamp] = useState("");
  const [updateCroSignAsSignature, setUpdateCroSignAsSignature] = useState("");
  const [updateCroSignAsAgent, setUpdateCroSignAsAgent] = useState("");
  const [updateDepot, setUpdateDepot] = useState("");
  const [updateDepotData, setUpdateDepotData] = useState("");
  const [updateDepotInstructions, setUpdateDepotInstructions] = useState("");
  const [updateRemark1, setUpdateRemark1] = useState("");
  const [updateRemark2, setUpdateRemark2] = useState("");
  const [updatePortnetReference, setUpdatePortnetReference] = useState("");
  const [updateContainerOperatorCode, setUpdateContainerOperatorCode] = useState("");
  const [updateContainerBsCode, setUpdateContainerBsCode] = useState("");

  const [addShipmentCroLoader, setAddShipmentCroLoader] = useState(false);
  const [updateShipmentCroLoader, setUpdateShipmentCroLoader] = useState(false);
  const [deleteShipmentCroLoader, setDeleteShipmentCroLoader] = useState(false);
  const [deleteShipmentCroId, setDeleteShipmentCroId] = useState("");
  const [issueShipmentCroLoader, setIssueShipmentCroLoader] = useState(false);
  const [cancelShipmentCroLoader, setCancelShipmentCroLoader] = useState(false);

  const [showPrintCroModal, setShowPrintCroModal] = useState(false);
  const [showPreviewPrintCroModal, setShowPreviewPrintCroModal] = useState(false);
  const [printWithStamp, setPrintWithStamp] = useState(false);
  const [printWithSignature, setPrintWithSignature] = useState(false);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  

  const getShipment = async (shipment_id) => {
    setShipmentDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/' + shipment_id);
      if (response) {
        setShipmentData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }
    setShipmentDataPending(false)
  }

  const getShipmentCro = async (shipment_id) => {
    setShipmentCroDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcro?shipment=' + shipment_id);
      if (response) {
        setShipmentCroData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment cro data! Try again.");
    }
    setShipmentCroDataPending(false)
  }

  useEffect(() => {
    getShipment(shipment_id)
    getShipmentCro(shipment_id)
  }, [shipment_id]);


  const shipmentcrocolumns = [
    {
      name: 'DO Number',
      selector: row => row.do_number,
      sortable: true,
    },
    {
      name: 'Version',
      selector: row => row.version,
      sortable: true,
    },
    {
      name: 'Booking Party',
      selector: row => row.shipment_data?.booking_party_data?.name,
      sortable: true,
    },
    {
      name: 'Depot',
      selector: row => row.depot_data?.name,
      sortable: true,
    },
    {
      name: 'Validity',
      selector: row => row.validity,
      sortable: true,
    },
    {
      name: 'Issue Date',
      selector: row => row.issue_date,
      sortable: true,
    },
    {
      name: 'Issued By',
      selector: row => row.issued_by_data?.name,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => <span className={`${row.status=="ISSUED"?"bg-success text-white px-2 rounded":row.status=="CANCELLED"?"bg-danger text-white px-2 rounded":""}`}>{row.status}</span>,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("shipment:cro:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" onClick={() => handleShowUpdateShipmentCroModal(row)}>
                <i className="fa fa-edit"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:cro:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Delete" onClick={() => handleDeleteShipmentCroModal(row)}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];

  const handleShowAddShipmentCroModal = () => {
    setShowAddShipmentCroModal(true)
  }

  const handleCloseAddShipmentCroModal = () => {
    setShowAddShipmentCroModal(false)
  }

  const handleShowUpdateShipmentCroModal = async (data) => {
    setShowUpdateShipmentCroModal(true)
    setUpdateShipmentCroId(data.id)
    setUpdateDoNumber(data?.do_number)
    setUpdateVersion(data?.version)
    setUpdateShipmentPoa(data?.shipment_data?.poa)
    setUpdateShipmentPol(data?.shipment_data?.pol)
    setUpdateShipmentPolTerminal(data?.shipment_data?.pol_terminal)
    setUpdateShipmentPod(data?.shipment_data?.pod)
    setUpdateShipmentFd(data?.shipment_data?.fd)
    setUpdateShipmentVessel(data?.shipment_data?.first_vessel_schedule_data?.vessel)
    setUpdateShipmentVesselVoyage(data?.shipment_data?.first_vessel_schedule_data?.voyage)
    setUpdateShipmentVesselOperator(data?.shipment_data?.slot_operator)
    setUpdateShipmentVesselEta(data?.shipment_data?.vessel_eta)
    setUpdateShipmentVesselGateOpen(data?.shipment_data?.vessel_gate_open)
    setUpdateShipmentVesselCutOff(data?.shipment_data?.vessel_cut_off)
    setUpdateShipmentVesselEtd(data?.shipment_data?.vessel_etd)
    setUpdateShipmentBookingParty(data?.shipment_data?.booking_party)
    setUpdateShipmentBookingItem(data?.shipment_data?.booking_line_item)
    setUpdateShipmentContainer(data?.containers)
    setUpdateCroStatus(data?.status)
    setUpdateCroValidity(data?.validity)
    setUpdateCroIssueDate(data?.issue_date)
    setUpdateCroIssuedBy(data?.issued_by)
    setUpdateCroSurveyor(data?.surveyor)
    setUpdateCroSignAs(data?.sign_as)
    setUpdateCroSignAsAgent(data?.sign_as_agent)
    setUpdateDepot(data?.depot)
    setUpdateDepotData(data?.depot_data)
    setUpdateDepotInstructions(data?.depot_instructions)
    setUpdateRemark1(data?.remark_1)
    setUpdateRemark2(data?.remark_2)
    setUpdatePortnetReference(data?.portnet_reference_number)
    setUpdateContainerOperatorCode(data?.container_operator_code)
    setUpdateContainerBsCode(data?.bs_code)

    if(data?.sign_as=="AGENT"){
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/agent/' + data?.sign_as_agent + '/');
      setUpdateCroSignAsName(response.data?.name)
      setUpdateCroSignAsStamp(response.data?.stamp)
      setUpdateCroSignAsSignature(response.data?.signature)
    }
    else if(data?.sign_as=="PRINCIPAL"){
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/principal/' + data?.sign_as_agent + '/');
      setUpdateCroSignAsName(response.data?.name)
      setUpdateCroSignAsStamp(response.data?.stamp)
      setUpdateCroSignAsSignature(response.data?.signature)
    }
  }

  const handleUpdateShipmentCroModalClose = () => {
    setShowUpdateShipmentCroModal(false)
    setUpdateShipmentCroId("")
    setUpdateDoNumber("")
    setUpdateVersion("")
    setUpdateShipmentPoa("")
    setUpdateShipmentPol("")
    setUpdateShipmentPolTerminal("")
    setUpdateShipmentPod("")
    setUpdateShipmentFd("")
    setUpdateShipmentVessel("")
    setUpdateShipmentVesselVoyage("")
    setUpdateShipmentVesselOperator("")
    setUpdateShipmentVesselEta("")
    setUpdateShipmentVesselGateOpen("")
    setUpdateShipmentVesselCutOff("")
    setUpdateShipmentVesselEtd("")
    setUpdateShipmentBookingParty("")
    setUpdateShipmentBookingItem("")
    setUpdateShipmentContainer("")
    setUpdateCroStatus("")
    setUpdateCroValidity("")
    setUpdateCroIssueDate("")
    setUpdateCroIssuedBy("")
    setUpdateCroSurveyor("")
    setUpdateCroSignAs("")
    setUpdateCroSignAsAgent("")
    setUpdateDepot("")
    setUpdateDepotInstructions("")
    setUpdateRemark1("")
    setUpdateRemark2("")
    setUpdatePortnetReference("")
    setUpdateContainerOperatorCode("")
    setUpdateContainerBsCode("")
  }

  const handleDeleteShipmentCroModal = (row) => {
    setShowDeleteShipmentCroModal(true)
    setDeleteShipmentCroId(row.id)
  }

  const addShipmentCro = async (e) => {
    e.preventDefault();
    setAddShipmentCroLoader(true)

    const data = {
      "shipment": shipment_id,
      "reference_number": shipmentData?.reference_number,
      "pol_terminal": addcroform.current.pol_terminal.value,
      "vessel_operator": addcroform.current.vessel_operator.value,
      "containers": Array.isArray(addcroform.current.containers.value) ? addcroform.current.containers.value: [addcroform.current.containers.value],
      "container_operator_code": addcroform.current.container_operator_code.value,
      "validity": addcroform.current.validity.value,
      "surveyor": addcroform.current.surveyor.value,
      "sign_as": addcroform.current.sign_as.value,
      "sign_as_agent": addcroform.current.sign_as_agent.value,
      "depot": addcroform.current.depot.value,
      "depot_instructions": addcroform.current.depot_instructions.value,
      "remark_1": addcroform.current.remark_1.value,
      "remark_2": addcroform.current.remark_2.value,
      "portnet_reference_number": addcroform.current.portnet_reference_number.value,
      "bs_code": addcroform.current.bs_code.value,
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcro/generatecro/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("CRO generated successfully");
        getShipmentCro(shipment_id)
        addcroform.current.pol_terminal.value = ""
        addcroform.current.vessel_operator.value = ""
        addcroform.current.containers.value = ""
        addcroform.current.container_operator_code.value = ""
        addcroform.current.validity.value = ""
        addcroform.current.surveyor.value = ""
        addcroform.current.sign_as.value = ""
        addcroform.current.sign_as_agent.value = ""
        addcroform.current.depot.value = ""
        addcroform.current.depot_instructions.value = ""
        addcroform.current.remark_1.value = ""
        addcroform.current.remark_2.value = ""
        addcroform.current.portnet_reference_number.value = ""
        addcroform.current.bs_code.value = ""
      }
    } catch (err) {
      toast.error("Error in generating cro! Try again.");
    }

    getShipmentCro(shipment_id)
    setAddShipmentCroLoader(false)
    setShowAddShipmentCroModal(false)
  }

  const updateShipmentCro = async (e) => {
    e.preventDefault();
    setUpdateShipmentCroLoader(true)


    const data = {
      "id": updateShipmentCroId,
      "shipment": shipment_id,
      "reference_number": shipmentData?.reference_number,
      "pol_terminal": updateShipmentPolTerminal,
      "vessel_operator": updateShipmentVesselOperator,
      "containers": Array.isArray(updateShipmentContainer.map(c => c.value)) ? updateShipmentContainer.map(c => c.value): [updateShipmentContainer.map(c => c.value)],
      "container_operator_code": updateContainerOperatorCode,
      "validity": updateCroValidity,
      "surveyor": updateCroSurveyor,
      "sign_as": updateCroSignAs,
      "sign_as_agent": updateCroSignAsAgent,
      "depot": updateDepot,
      "depot_instructions": updateDepotInstructions,
      "remark_1": updateRemark1,
      "remark_2": updateRemark2,
      "portnet_reference_number": updatePortnetReference,
      "bs_code": updateContainerBsCode,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcro/updatecro/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("CRO updated successfully");
        getShipmentCro(shipment_id)
      }
    } catch (err) {
      toast.error("Error in updating cro! Try again.");
    }

    getShipmentCro(shipment_id)
    setShowUpdateShipmentCroModal(false)
    setUpdateShipmentCroLoader(false)
  }

  const deleteShipmentCro = async (e) => {
    e.preventDefault();
    setDeleteShipmentCroLoader(true)

    const id = deleteShipmentCroId

    try {
      const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcro/' + id + '/');

      if (response.status == 204) {
        toast.success("Freight charge deleted successfully");
        getShipmentCro(shipment_id)
      }
    } catch (err) {
      toast.error("Error in deleting freight charge! Try again.");
    }
    setDeleteShipmentCroLoader(false)
    setShowDeleteShipmentCroModal(false)
  }

  const issueCro = async (e) => {
    e.preventDefault();
    setIssueShipmentCroLoader(true)


    const data = {
      "id": updateShipmentCroId,
      "status": "ISSUED",
      "issue_date": format(new Date(), 'yyyy-MM-dd'),
      "issued_by": loggedInUser?.id,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcro/'+updateShipmentCroId+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("CRO issued successfully");
        getShipmentCro(shipment_id)
      }
    } catch (err) {
      toast.error("Error in issuing cro! Try again.");
    }

    getShipmentCro(shipment_id)
    setShowIssueCroModal(false)
    setShowUpdateShipmentCroModal(false)
    setIssueShipmentCroLoader(false)
  }

  const cancelCro = async (e) => {
    e.preventDefault();
    setCancelShipmentCroLoader(true)

    const data = {
      "id": updateShipmentCroId,
      "status": "CANCELLED",
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcro/'+updateShipmentCroId+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("CRO cancelled successfully");
        getShipmentCro(shipment_id)
      }
    } catch (err) {
      toast.error("Error in cancelling cro! Try again.");
    }

    getShipmentCro(shipment_id)
    setShowCancelCroModal(false)
    setShowUpdateShipmentCroModal(false)
    setCancelShipmentCroLoader(false)
  }

  return (
    <div>
      <div className="col-12 text-left" style={{ marginTop: -5 }}>
        <div className="row">
          <div className="col-9">
            <Button className="btn btn-inox-green border-0" onClick={() => handleShowAddShipmentCroModal()}>Add CRO</Button>
          </div>
        </div>


        <DataTable
          columns={shipmentcrocolumns}
          data={shipmentCroData}
          progressPending={shipmentCroDataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center table-no-data">No CRO Found</p>}
          highlightOnHover
          customStyles={userTableCustomStyles}
          dense
        />
      </div>

      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showAddShipmentCroModal} onHide={() => handleCloseAddShipmentCroModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add CRO</Modal.Title>
        </Modal.Header>
        <Modal.Body>          
          <form ref={addcroform}>
            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Do Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">DO Number</label>
                    <div class="col-12">
                      <input type="text" id="do_number" name="do_number" className="form-control form-control-sm" disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Version</label>
                    <div class="col-12">
                      <input type="text" id="version" name="version" className="form-control form-control-sm" disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="booking_party" class="col-12 col-form-label font-12px">Booking Party</label>
                    <div class="col-12">
                      <select id="booking_party" name="booking_party" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.booking_party==""?true:false}>Select Booking Party</option>
                        {userList?.map(user => (
                          <option value={user.id} selected={shipmentData?.booking_party==user.id?true:false}>{user.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Route</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="poa" class="col-12 col-form-label font-12px">POA</label>
                    <div class="col-12">
                      <select id="poa" name="poa" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.poa==""?true:false}>Select POA</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.poa==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pol" class="col-12 col-form-label font-12px">POL</label>
                    <div class="col-12">
                      <select id="pol" name="pol" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.pol==""?true:false}>Select POL</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.pol==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pod" class="col-12 col-form-label font-12px">POD</label>
                    <div class="col-12">
                      <select id="pod" name="pod" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.pod==""?true:false}>Select POD</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.pod==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="fd" class="col-12 col-form-label font-12px">FD</label>
                    <div class="col-12">
                      <select id="fd" name="fd" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.fd==""?true:false}>Select FD</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.fd==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pol_terminal" class="col-12 col-form-label font-12px">POL Terminal</label>
                    <div class="col-12">
                      <select id="pol_terminal" name="pol_terminal" className="form-select form-select-sm">
                        <option value="" selected={shipmentData?.pol_terminal==""?true:false}>Select Terminal</option>
                        {terminalList?.map(terminal => (
                          <option value={terminal.id} selected={shipmentData?.pol_terminal==terminal.id?true:false}>{terminal.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Vessel Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Vessel</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.first_vessel_schedule_data?.vessel_data?.id == "" ? true : false}>Select Vessel</option>
                        {vesselList?.map(vessel => (
                          <option value={vessel.id} selected={vessel.id == shipmentData?.first_vessel_schedule_data?.vessel_data?.id ? true : false}>{vessel.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Voyage</label>
                    <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="voyage" name="voyage" value={shipmentData?.first_vessel_schedule_data?.voyage} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Vessel Operator</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="vessel_operator" name="vessel_operator">
                        <option value="" selected={shipmentData?.slot_operator == "" ? true : false}>Select Operator</option>
                        {operatorList?.map(operator => (
                          <option value={operator.id} selected={operator.id == shipmentData?.slot_operator ? true : false}>{operator.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">ETA</label>
                    <div class="col-12">
                      <input type="datetime-local" className="form-control form-control-sm" id="vessel_eta" name="vessel_eta" value={shipmentData?.vessel_eta} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Gate Open</label>
                    <div class="col-12">
                      <input type="datetime-local" className="form-control form-control-sm" id="vessel_gate_open" name="vessel_gate_open" value={shipmentData?.vessel_gate_open} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Cut Off</label>
                    <div class="col-12">
                      <input type="datetime-local" className="form-control form-control-sm" id="vessel_cut_off" name="vessel_cut_off" value={shipmentData?.vessel_cut_off} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">ETD</label>
                    <div class="col-12">
                      <input type="datetime-local" className="form-control form-control-sm" id="vessel_etd" name="vessel_etd" value={shipmentData?.vessel_etd} disabled/>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Cargo and Containers</legend>
              {shipmentData?.booking_line_item?.map(item => (
                <div className="row">
                  <div className="col-3">
                    <div class="form-group mb-2">
                      <label class="col-12 col-form-label font-12px">Container</label>
                      <div class="col-12">
                        <select className="form-select form-select-sm" disabled>
                          <option value="" selected={item?.container_type == "" ? true : false}>Select Container</option>
                          {containerList?.map(container => (
                            <option value={container.product_name} selected={container.product_name == item?.container_type ? true : false}>{container.product_name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div class="form-group mb-2">
                      <label class="col-12 col-form-label font-12px">Quantity</label>
                      <div class="col-12">
                        <input type="number" className="form-control form-control-sm" min={1} value={item.container_quantity} disabled />
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div class="form-group mb-2">
                      <label class="col-12 col-form-label font-12px">Cargo Type</label>
                      <div class="col-12">
                        <select className="form-select form-select-sm" disabled>
                          <option value="" selected={item?.cargo_type == "" ? true : false}>Select Cargo type</option>
                          <option value="NON_HAZARDOUS" selected={item?.cargo_type == "NON_HAZARDOUS" ? true : false}>NON HAZARDOUS</option>
                          <option value="HAZARDOUS" selected={item?.cargo_type == "HAZARDOUS" ? true : false}>HAZARDOUS</option>

                          <option value="EMPTY" selected={item?.cargo_type == "EMPTY" ? true : false}>EMPTY</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div class="form-group mb-2">
                      <label class="col-12 col-form-label font-12px">Cargo</label>
                      <div class="col-12">
                        <select className="form-select form-select-sm" disabled>
                          <option value="" selected={item?.commodity == "" ? true : false}>Select Cargo</option>
                          {cargoList?.map(cargo => (
                            <option value={cargo.name} selected={cargo.name == item?.commodity ? true : false}>{cargo.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="weight" class="col-12 col-form-label font-12px">Weight (MT)</label>
                    <div class="col-12">
                      <input type="number" id="weight" name="weight" className="form-control form-control-sm" value={shipmentData?.weight} disabled />
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="containers" class="col-12 col-form-label font-12px">Containers</label>
                    <div class="col-12">
                      <Select
                        options={selectableContainerList.filter(item => item.location === shipmentData?.pol && item.status == "EMPTY_AV")}
                        id="containers"
                        name="containers"
                        isMulti={true}
                        isClearable
                        className="px-0"
                        styles={smallFormSelectCustomStyles}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="container_operator_code" class="col-12 col-form-label font-12px">Container Operator Code</label>
                    <div class="col-12">
                      <input type="text" id="container_operator_code" name="container_operator_code" className="form-control form-control-sm" />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Validity Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Validity</label>
                    <div class="col-12">
                      <input type="date" className="form-control" id="validity" name="validity" />
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Issue Date</label>
                    <div class="col-12">
                      <input type="date" className="form-control" id="issue_date" name="issue_date" disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Issued By</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="issued_by" name="issued_by" disabled>
                        <option value="" selected={updateCroIssuedBy == "" ? true : false}>Select User</option>
                        {userList?.map(user => (
                          <option value={user.id} selected={user.id == updateCroIssuedBy ? true : false}>{user.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Document Signature</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Surveyor</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="surveyor" name="surveyor">
                        <option value="" selected={updateCroSurveyor == "" ? true : false}>Select User</option>
                        {userList?.map(user => (
                          <option value={user.id} selected={user.id == updateCroSurveyor ? true : false}>{user.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Sign As</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="sign_as" name="sign_as">
                        <option value="" selected={updateCroSignAs == "" ? true : false}>Select Sign As</option>
                        <option value="PRINCIPAL" selected={updateCroSignAs == "PRINCIPAL" ? true : false}>PRINCIPAL</option>
                        <option value="AGENT" selected={updateCroSignAs == "AGENT" ? true : false}>AGENT</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Sign As Agent</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="sign_as_agent" name="sign_as_agent">
                        <option value="" selected={updateCroSignAsAgent == "" ? true : false}>Select Agent</option>
                        {agentList?.map(agent => (
                          <option value={agent.id} selected={agent.id == updateCroSignAsAgent ? true : false}>{agent.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Depot</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Depot</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="depot" name="depot">
                        <option value="" selected={updateDepot == "" ? true : false}>Select Depot</option>
                        {depotList?.map(depot => (
                          <option value={depot.id} selected={depot.id == updateDepot ? true : false}>{depot.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Depot Instructions</label>
                    <div class="col-12">
                      <textarea rows={4} className="form-control form-control-sm" id="depot_instructions" name="depot_instructions"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Remarks & Other Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Remark 1</label>
                    <div class="col-12">
                      <textarea rows={4} className="form-control form-control-sm" id="remark_1" name="remark_1"></textarea>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Remark 2</label>
                    <div class="col-12">
                      <textarea rows={4} className="form-control form-control-sm" id="remark_2" name="remark_2"></textarea>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Portnet Reference Number</label>
                    <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="portnet_reference_number" name="portnet_reference_number" />
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">BS Code</label>
                    <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="bs_code" name="bs_code" />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <div className="col-12 text-center">
              <Button className="btn btn-inox-green border-0 mt-3" onClick={(e) => addShipmentCro(e)}>
                {addShipmentCroLoader ?
                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Add CRO"
                }
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showUpdateShipmentCroModal} onHide={() => [handleUpdateShipmentCroModalClose(), setPrintWithStamp(false), setPrintWithSignature(false)]} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update CRO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div class="dropdown">
                <button type="button" style={{ paddingTop: 7, paddingBottom: 8, float: 'right' }} title="Language" class="btn btn-inox-green border-0 text-white" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span class="d-flex align-items-center">
                    <span className="fa fa-bars"></span>
                  </span>
                </button>

                <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                  {updateCroStatus!="ISSUED"?
                  <span class="dropdown-item pointer pointer" onClick={() => setShowIssueCroModal(true)}>
                    <i className="fa fa-check text-success"></i><span className="mx-2">Issue</span>
                  </span>
                  :""}

                  {updateCroStatus!="CANCELLED"?
                  <span class="dropdown-item pointer pointer" onClick={() => setShowCancelCroModal(true)}>
                    <i className="fa fa-times text-danger"></i><span className="mx-2">Cancel</span>
                  </span>
                  :""}

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("All")}>
                    <i className="fa fa-edit text-warning"></i><span className="mx-2">Ammend</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("All")}>
                    <i className="fa fa-ship text-info"></i><span className="mx-2">Update Vessel</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("All")}>
                    <i className="fa fa-calendar text-secondary"></i><span className="mx-2">Update Validity</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => setShowPrintCroModal(true)}>
                    <i className="fa fa-print text-inox-green"></i><span className="mx-2">Print</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("All")}>
                    <i className="fa fa-envelope text-success"></i><span className="mx-2">Email</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <form>
            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Do Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">DO Number</label>
                    <div class="col-12">
                      <input type="text" id="do_number" name="do_number" className="form-control form-control-sm" value={updateDoNumber} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Version</label>
                    <div class="col-12">
                      <input type="text" id="version" name="version" className="form-control form-control-sm" value={updateVersion} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="booking_party" class="col-12 col-form-label font-12px">Booking Party</label>
                    <div class="col-12">
                      <select id="booking_party" name="booking_party" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.booking_party==""?true:false}>Select Booking Party</option>
                        {userList?.map(user => (
                          <option value={user.id} selected={shipmentData?.booking_party==user.id?true:false}>{user.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Route</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="poa" class="col-12 col-form-label font-12px">POA</label>
                    <div class="col-12">
                      <select id="poa" name="poa" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.poa==""?true:false}>Select POA</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.poa==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pol" class="col-12 col-form-label font-12px">POL</label>
                    <div class="col-12">
                      <select id="pol" name="pol" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.pol==""?true:false}>Select POL</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.pol==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pod" class="col-12 col-form-label font-12px">POD</label>
                    <div class="col-12">
                      <select id="pod" name="pod" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.pod==""?true:false}>Select POD</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.pod==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="fd" class="col-12 col-form-label font-12px">FD</label>
                    <div class="col-12">
                      <select id="fd" name="fd" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.fd==""?true:false}>Select FD</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.fd==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pol_terminal" class="col-12 col-form-label font-12px">POL Terminal</label>
                    <div class="col-12">
                      <select id="pol_terminal" name="pol_terminal" className="form-select form-select-sm" onChange={(e) => setUpdateShipmentPolTerminal(e.target.value)}>
                        <option value="" selected={updateShipmentPolTerminal==""?true:false}>Select Terminal</option>
                        {terminalList?.map(terminal => (
                          <option value={terminal.id} selected={updateShipmentPolTerminal==terminal.id?true:false}>{terminal.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Vessel Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Vessel</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.first_vessel_schedule_data?.vessel_data?.id == "" ? true : false}>Select Vessel</option>
                        {vesselList?.map(vessel => (
                          <option value={vessel.id} selected={vessel.id == shipmentData?.first_vessel_schedule_data?.vessel_data?.id ? true : false}>{vessel.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Voyage</label>
                    <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="voyage" name="voyage" value={shipmentData?.first_vessel_schedule_data?.voyage} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Vessel Operator</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="vessel_operator" name="vessel_operator" onChange={(e) => setUpdateShipmentVesselOperator(e.target.value)}>
                        <option value="" selected={updateShipmentVesselOperator == "" ? true : false}>Select Operator</option>
                        {operatorList?.map(operator => (
                          <option value={operator.id} selected={operator.id == updateShipmentVesselOperator ? true : false}>{operator.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">ETA</label>
                    <div class="col-12">
                      <input type="datetime-local" className="form-control form-control-sm" id="vessel_eta" name="vessel_eta" value={shipmentData?.vessel_eta} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Gate Open</label>
                    <div class="col-12">
                      <input type="datetime-local" className="form-control form-control-sm" id="vessel_gate_open" name="vessel_gate_open" value={shipmentData?.vessel_gate_open} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Cut Off</label>
                    <div class="col-12">
                      <input type="datetime-local" className="form-control form-control-sm" id="vessel_cut_off" name="vessel_cut_off" value={shipmentData?.vessel_cut_off} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">ETD</label>
                    <div class="col-12">
                      <input type="datetime-local" className="form-control form-control-sm" id="vessel_etd" name="vessel_etd" value={shipmentData?.vessel_etd} disabled/>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Cargo and Containers</legend>
              {shipmentData?.booking_line_item?.map(item => (
                <div className="row">
                  <div className="col-3">
                    <div class="form-group mb-2">
                      <label class="col-12 col-form-label font-12px">Container</label>
                      <div class="col-12">
                        <select className="form-select form-select-sm" disabled>
                          <option value="" selected={item?.container_type == "" ? true : false}>Select Container</option>
                          {containerList?.map(container => (
                            <option value={container.product_name} selected={container.product_name == item?.container_type ? true : false}>{container.product_name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div class="form-group mb-2">
                      <label class="col-12 col-form-label font-12px">Quantity</label>
                      <div class="col-12">
                        <input type="number" className="form-control form-control-sm" min={1} value={item.container_quantity} disabled />
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div class="form-group mb-2">
                      <label class="col-12 col-form-label font-12px">Cargo Type</label>
                      <div class="col-12">
                        <select className="form-select form-select-sm" disabled>
                          <option value="" selected={item?.cargo_type == "" ? true : false}>Select Cargo type</option>
                          <option value="NON_HAZARDOUS" selected={item?.cargo_type == "NON_HAZARDOUS" ? true : false}>NON HAZARDOUS</option>
                          <option value="HAZARDOUS" selected={item?.cargo_type == "HAZARDOUS" ? true : false}>HAZARDOUS</option>

                          <option value="EMPTY" selected={item?.cargo_type == "EMPTY" ? true : false}>EMPTY</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div class="form-group mb-2">
                      <label class="col-12 col-form-label font-12px">Cargo</label>
                      <div class="col-12">
                        <select className="form-select form-select-sm" disabled>
                          <option value="" selected={item?.commodity == "" ? true : false}>Select Cargo</option>
                          {cargoList?.map(cargo => (
                            <option value={cargo.name} selected={cargo.name == item?.commodity ? true : false}>{cargo.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="weight" class="col-12 col-form-label font-12px">Weight (MT)</label>
                    <div class="col-12">
                      <input type="number" id="weight" name="weight" className="form-control form-control-sm" value={shipmentData?.weight} disabled />
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="containers" class="col-12 col-form-label font-12px">Containers</label>
                    <div class="col-12">
                      <Select
                        options={selectableContainerList.filter(item => item.location === shipmentData?.pol && item.status == "EMPTY_AV")}
                        id="containers"
                        name="containers"
                        isMulti={true}
                        isClearable
                        className="px-0"
                        styles={smallFormSelectCustomStyles}
                        value={updateShipmentContainer}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="container_operator_code" class="col-12 col-form-label font-12px">Container Operator Code</label>
                    <div class="col-12">
                      <input type="text" id="container_operator_code" name="container_operator_code" className="form-control form-control-sm" value={updateContainerOperatorCode}
                      onChange={(e) => setUpdateContainerOperatorCode(e.target.value)}/>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Validity Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Validity</label>
                    <div class="col-12">
                      <input type="date" className="form-control" id="validity" name="validity" value={updateCroValidity} onChange={(e) => setUpdateCroValidity(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Issue Date</label>
                    <div class="col-12">
                      <input type="date" className="form-control" id="issue_date" name="issue_date" disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Issued By</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="issued_by" name="issued_by" disabled>
                        <option value="" selected={updateCroIssuedBy == "" ? true : false}>Select User</option>
                        {userList?.map(user => (
                          <option value={user.id} selected={user.id == updateCroIssuedBy ? true : false}>{user.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Document Signature</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Surveyor</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="surveyor" name="surveyor" onChange={(e) => setUpdateCroSurveyor(e.target.value)}>
                        <option value="" selected={updateCroSurveyor == "" ? true : false}>Select User</option>
                        {userList?.map(user => (
                          <option value={user.id} selected={user.id == updateCroSurveyor ? true : false}>{user.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Sign As</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="sign_as" name="sign_as" onChange={(e) => setUpdateCroSignAs(e.target.value)}>
                        <option value="" selected={updateCroSignAs == "" ? true : false}>Select Sign As</option>
                        <option value="PRINCIPAL" selected={updateCroSignAs == "PRINCIPAL" ? true : false}>PRINCIPAL</option>
                        <option value="AGENT" selected={updateCroSignAs == "AGENT" ? true : false}>AGENT</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Sign As Agent</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="sign_as_agent" name="sign_as_agent" onChange={(e) => setUpdateCroSignAsAgent(e.target.value)}>
                        <option value="" selected={updateCroSignAsAgent == "" ? true : false}>Select Agent</option>
                        {agentList?.map(agent => (
                          <option value={agent.id} selected={agent.id == updateCroSignAsAgent ? true : false}>{agent.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Depot</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Depot</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" id="depot" name="depot" onChange={(e) => setUpdateDepot(e.target.value)}>
                        <option value="" selected={updateDepot == "" ? true : false}>Select Depot</option>
                        {depotList?.map(depot => (
                          <option value={depot.id} selected={depot.id == updateDepot ? true : false}>{depot.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Depot Instructions</label>
                    <div class="col-12">
                      <textarea rows={4} className="form-control form-control-sm" id="depot_instructions" name="depot_instructions"
                      value={updateDepotInstructions} onChange={(e) => setUpdateDepotInstructions(e.target.value)}></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Remarks & Other Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Remark 1</label>
                    <div class="col-12">
                      <textarea rows={4} className="form-control form-control-sm" id="remark_1" name="remark_1"
                      value={updateRemark1} onChange={(e) => setUpdateRemark1(e.target.value)}></textarea>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Remark 2</label>
                    <div class="col-12">
                      <textarea rows={4} className="form-control form-control-sm" id="remark_2" name="remark_2"
                      value={updateRemark2} onChange={(e) => setUpdateRemark2(e.target.value)}></textarea>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Portnet Reference Number</label>
                    <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="portnet_reference_number" name="portnet_reference_number" 
                      value={updatePortnetReference} onChange={(e) => setUpdatePortnetReference(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">BS Code</label>
                    <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="bs_code" name="bs_code" 
                      value={updateContainerBsCode} onChange={(e) => setUpdateContainerBsCode(e.target.value)}/>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <div className="col-12 text-center">
              <Button className="btn btn-inox-green border-0 mt-3" onClick={(e) => [updateShipmentCro(e), setPrintWithStamp(false), setPrintWithSignature(false)]}>
                {updateShipmentCroLoader ?
                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Update CRO"
                }
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showDeleteShipmentCroModal} onHide={() => setShowDeleteShipmentCroModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete CRO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-12">
                Do you want to delete this cro?
              </div>

              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={(e) => setShowDeleteShipmentCroModal(false)}>Cancel</Button>

                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => deleteShipmentCro(e)}>
                  {deleteShipmentCroLoader ?
                    <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    :
                    "Delete"
                  }
                </Button>


              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      {/*  ---------------------------_PRINT CRO ---------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showPrintCroModal} onHide={() => setShowPrintCroModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Options</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-12">
                <label className="d-flex align-items-center">
                  <input type="checkbox" className="me-2" onChange={(e) => setPrintWithStamp(e.target.checked)}/> Print With Stamp
                </label>

                <label className="d-flex align-items-center mt-2">
                  <input type="checkbox" className="me-2" onChange={(e) => setPrintWithSignature(e.target.checked)}/> Print With Signature
                </label>
              </div>

              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => [setShowPrintCroModal(false), setPrintWithStamp(false), setPrintWithSignature(false)]}>Cancel</Button>

                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => [setShowPreviewPrintCroModal(true), setShowPrintCroModal(false)]}>Preview</Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showPreviewPrintCroModal} onHide={() => [setShowPreviewPrintCroModal(false), setPrintWithStamp(false), setPrintWithSignature(false)]} centered>
        <Modal.Header closeButton>
          <Modal.Title>Print CRO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div id="croDocument" className="col-12" style={{ textTransform: 'uppercase', fontSize: '12px', paddingTop: "30px" }}>
              <div className="row">
                <div className="col-2">
                  <img src={logoInoxShipping} class="img-fluid" width="80%"></img>
                </div>
                <div className="col-8 text-center">
                  <h4>INOX SHIPPING AGENCIES (INDIA) PVT LTD</h4>
                  <p className="font-12px">A- WING, OFFICE # 108 & 109 1ST FLOOR, HERMES ATRIUM, SECTOR 11, CBD BELAPUR, NAVI MUMBAI - 400614, MAHARASHTRA, INDIA GST#: 27AAECI6725P1ZZ</p>
                  <p className="font-12px"><b>PHONE:</b> +91 9082813976 | <b>EMAIL:</b> IMPORTS@INOXSHIPPING.COM <b>PAN:</b> AAECI6725P</p>
                </div>
                <div className="col-2">
                  <img src={logoInoxShipping} class="img-fluid float-right" width="80%"></img>
                </div>
              </div>

              <div className="row">
                <p className="border-top border-bottom text-center fw-bold">CONTAINER RELEASE ORDER</p>
              </div>

              <div className="row mb-2">
                <p className="mb-0"><b>Reference No:</b> {updateDoNumber}</p>
                <p className="mb-0"><b>Issue Date:</b> {updateCroIssueDate? format(new Date(updateCroIssueDate), "dd MMMM,yyyy"): ""}</p>
                <p className="mb-0"><b>Validity:</b> {updateCroValidity? format(new Date(updateCroValidity), "dd MMMM,yyyy"): ""}</p>
              </div>

              <div className="row mx-1">
                <div className="col-6 border py-2">
                  <p className="mb-0">TO</p>
                  <p>THE MANAGER,</p>
                  <p className="mb-0 fw-bold">{updateDepotData?.company_name}</p>
                  <p className="mb-0">{updateDepotData?.address_line_1}, {updateDepotData?.address_line_2}, {updateDepotData?.city} - {updateDepotData?.pincode},</p> 
                  <p className="mb-0">{updateDepotData?.state}, {updateDepotData?.country_data?.long_name}</p>
                  <p className="mb-0 fw-bold">Pick-up letter vallid upto {updateCroValidity? format(new Date(updateCroValidity), "dd MMMM,yyyy"): ""} (Midnight)</p>
                </div>
                  
                <div className="col-3">
                  <div className="row">
                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>POA</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.poa_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>POD</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.pod_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>POL TERMINAL</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.pol_terminal_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>VESSEL/VOYAGE</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.first_vessel_schedule_data?.vessel_data?.name} / {shipmentData?.first_vessel_schedule_data?.vessel_data?.voyage}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>ETA</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.vessel_eta? format(new Date(shipmentData?.vessel_eta), "dd MMMM,yyyy, hh:mm a"): ""}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>CUT-OFF</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.vessel_cut_off? format(new Date(shipmentData?.vessel_cut_off), "dd MMMM,yyyy, hh:mm a"): ""}</p>
                    </div>
                  </div>
                </div>
                
               <div className="col-3">
                  <div className="row">
                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>POL</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.pol_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>FD</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.fd_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>CONTAINER OPERATOR CODE</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.pol_terminal_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>VESSEL OPERATOR</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.slot_operator_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>GATE OPEN</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.vessel_gate_open? format(new Date(shipmentData?.vessel_gate_open), "dd MMMM,yyyy, hh:mm a"): ""}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>ETD</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.vessel_etd? format(new Date(shipmentData?.vessel_etd), "dd MMMM,yyyy, hh:mm a"): ""}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row border mx-1">
                <div className="col-6 py-2">
                  <p className="mb-0">Dear Sir/Madam,</p>
                  <p className="mb-0">Please release <b>{shipmentData?.booking_line_item?.[0]?.container_quantity} x {shipmentData?.booking_line_item?.[0]?.container_type}</b> to <b>MAC-NELS CONTAINER LINES PVT.LTD.</b></p>
                  <p>PLS ISSUE CARGO WORTHY CONTAINER</p>

                  <p className="mb-0"><b>CARGO TYPE :</b> {shipmentData?.booking_line_item?.[0]?.cargo_type.replaceAll("_", " ")}</p>
                  <p className="mb-0"><b>COMMODITY :</b> {shipmentData?.booking_line_item?.[0]?.commodity}</p>
                </div>

                <div className="col-6 py-2 text-center">
                  {printWithStamp?<img src={updateCroSignAsStamp} class="img-fluid" height={100} width={100}></img>:""}
                  {printWithSignature?<img src={updateCroSignAsSignature} class="img-fluid" height={100} width={100}></img>:""}
                  <div className="py-2 text-center d-flex flex-column justify-content-end" style={{ "height": printWithStamp|printWithSignature?"":"150px" }}>
                    <p className="mb-0 ">{updateCroSignAsName}</p>
                    <p>AS {updateCroSignAs}</p>
                  </div>
                </div>
              </div>

              <div className="row border mx-1">
                <div className="col-12 py-2">
                  <p><b>Instructions:</b></p>
                  <p className="mb-0">If laden containers could not Gate-in for the planned vessel, please inform us min. 48 hrs. prior as we need to achieve 100% utilization of form 13 issued by Terminal or else any penalty/consequences imposed by VOA or Terminal will be billed back to the shipper.</p>
                  <p className="mb-0">Container(s) needs to be gated-in with-in 7 days of the pick-up date, else export detention would be applicable.</p>
                </div>
              </div>
            </div>

            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => [setShowPreviewPrintCroModal(false), setPrintWithStamp(false), setPrintWithSignature(false)]}>Cancel</Button>

              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={() => downloadPDF("croDocument", "cro_"+updateDoNumber)}>Print</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/*  --------------------------- ISSUE CRO --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showIssueCroModal} onHide={() => setShowIssueCroModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Issue CRO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <p>Do you want to issue this CRO?</p>
              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => setShowIssueCroModal(false)}>Cancel</Button>
                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => issueCro(e)}>
                  {issueShipmentCroLoader ?
                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Issue"
                }
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/*  --------------------------- ISSUE CRO --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showCancelCroModal} onHide={() => setShowCancelCroModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cancel CRO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <p>Do you want to cancel this CRO?</p>
              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => setShowCancelCroModal(false)}>Cancel</Button>
                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => cancelCro(e)}>
                  {cancelShipmentCroLoader ?
                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Cancel"
                }
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default PlannedExportExpenses;
